<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
    :max-width="800"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Aluminum Die</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          cols="6"
          class="pb-0"
        >
          <v-text-field
            v-model="item.code"
            :rules="[(v) => !!v && v.trim().length > 0 || 'Code is required']"
          >
            <template slot="label">
              Code<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="3"
          class="pb-0"
          >
          <v-select
            v-model="item.type_id"
            :items="types"
            :rules="[(v) => !!v || 'Type is required']"
            item-text="name"
            item-value="id"
          >
            <template slot="label">
              Type<RedAsterisk />
            </template>
          </v-select>
        </v-col>
        <v-col
          cols="3"
          class="pb-0"
          >
          <v-text-field
            v-model="item.weight_ratio"
            :rules="[(v) => !!v || 'Weight ratio is required']"
            type="number"
            min="0"
            suffix="kg/inch"
          >
            <template slot="label">
              Weight Ratio<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="pb-0"
        >
          <v-text-field
            v-model="item.description"
            label="Description"
          />
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      code: '',
      description: '',
      type_id: null,
      weight_ratio: '',
    },
    types: [],
  }),
  created() {
    this.item = { ...this.itemDto };
    this.getTypes();
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.aluminumDie.read(submitModel);
      if (!res || res.data < 1 || !res.data[0]) {
        this.$bus.$emit('showError', 'Unable to retrieve this item');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
    },

    async getTypes() {
      const finishedGoodCommercialTypeIdFrame = 3;
      const finishedGoodCommercialTypeIdSlab = 4;
      const submitModel = {
        filters: {
          id: [finishedGoodCommercialTypeIdFrame, finishedGoodCommercialTypeIdSlab],
        },
      };
      const res = await this.$api.finishedGoodCommercialType.read(submitModel);
      if (!res) {
        this.$bus.$emit('showError', 'Unable to retrieve types');
        return;
      }
      this.types = res;
    },

    async submit() {
      if (!this.item) return false;
      this.item.code = this.item.code.trim();
      if (!this.item.code) {
        this.$bus.$emit('showError', 'Code is required');
        return false;
      }
      if (!this.item.type_id) {
        this.$bus.$emit('showError', 'Type is required');
        return false;
      }
      if (!this.item.weight_ratio) {
        this.$bus.$emit('showError', 'Weight Ratio is required');
        return false;
      }
      let res;
      if (this.item.id) {
        res = await this.$api.aluminumDie.update(this.item);
      } else {
        res = await this.$api.aluminumDie.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
